<div class="ui raised segment margin-bottom-10">
    <div class="ui stackable grid">
        <div class="two wide column">
            <img src="{{occasion.picture}}" class="image">
        </div>
        <div class="twelve wide column occasion-data">
            <h3>{{occasion.name}}</h3>
            <p>{{occasion.date.toLocaleDateString()}}</p>
            <p>{{occasion.price + "€"}}</p>
        </div>
        <div class="two wide column">
            <button *ngIf="!shared" class="ui icon button facebook-button" (click)="share()">
                <i class="ui facebook icon"></i>
            </button>
            <i *ngIf="shared" class="ui check green large icon ok-icon"></i>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/occasions/presentation/adminOccasion/adminOccasion.html